import React from 'react';
import { createRoot } from 'react-dom/client';
import { initI18nFromSSR } from './i18n/initFromSSR';
import ProductQuickAddToCart, { ProductQuickAddToCartProps } from './features/productquickaddtocart/ProductQuickAddToCart';

// Initialize i18n promise (only once, shared across renders)
const i18nInitPromise = initI18nFromSSR();

// Export render function for use in main.js
const ProductQuickAddToCartReact = {
    render: (container: HTMLElement, props: ProductQuickAddToCartProps) => {
        // Đợi translations load xong trước khi render
        i18nInitPromise.then(() => {
            const root = createRoot(container);
            root.render(<ProductQuickAddToCart {...props} />);
        });
    }
};

// Make it available globally immediately when this module loads
(window as any).ProductQuickAddToCartReact = ProductQuickAddToCartReact;

export default ProductQuickAddToCart;
